import { useEffect } from 'react';

var useMount = function useMount(fn) {
  useEffect(function () {
    fn();
  }, []);
};

export default useMount;


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/useMount/index.js
// module id = 7499
// module chunks = 2